import useWebpFile from "../components/Picture/useWebpFile";
import React from "react";
import styled from "styled-components";

const GlobalStyles = styled.div<{$infoIcon: string}>`
    // Global body size
    font-family: "National2";
    font-size: 0.889rem;

    .h1, h1 {
        font-size: 3.333rem;
        font-family: "National2";
        font-weight: 350;
    }

    .h2, h2 {
        font-size: 2.222rem;
        font-family: "National2";
        font-weight: 350;
    }

    .h3, h3 {
        font-size: 1.333rem;
        font-family: "National2";
        font-weight: 500;
    }

    .h4, h4 {
        font-size: 1.333rem;
        font-family: "National2";
        font-weight: 350;
        text-transform: uppercase;
    }

    .h5, h5 {
        font-size: 1.111rem;
        font-family: "National2";
        font-weight: 700;
    }

    .h6, h6 {
        font-size: 0.889rem;
        font-family: "National2 Narrow";
        font-weight: 700;
        text-transform: uppercase;
    }
    .xl-header {
        font-size: 7.111rem;
        font-family: "National2";
        font-weight: 500;
        text-transform: capitalize;
    }
    .overlay {
        h1 {
            font-size: 2.556rem;
            font-family: "National2";
            font-weight: 700;
        }
        h2 {
            font-size: 1.611rem;
            font-family: "jubilat-variable",sans-serif;
            font-weight: 400;
            font-variation-settings: 'wght' 350;
        }
    }
    .flex-column {
        .overlay {
            h2 {
                font-size: 1.25rem;
                font-family: "jubilat-variable",sans-serif;
                font-weight:400;
                font-variation-settings: 'wght' 350;
            }
        }
    }

    small, .small {
        font-weight: unset;
    }

    .btn {
        &.dropdown {
            &,
            &:focus,
            &:active,
            &:focus:active {
                outline: none;
            }

            &.dropdown-toggle {
                &,
                &:focus,
                &:active,
                &:focus:active {
                    outline: none;
                }
            }
        }
    }

    div.info-icon {
        display: inline-block;
        background-size: 15px;
        width: 15px;
        height: 15px;
        background-image: url(${props => props.$infoIcon});
    }

    .macu-tooltip-content {
        padding: 0 !important;
        opacity: 1 !important;
        font-size: 0.722rem !important;
        line-height: 1.25 !important;
        max-width: 500px;
        z-index: 1060;
        box-shadow: rgba(0, 0, 0, 0.05) 0px 4px 4px 0px;

        &__close-container {
            display: none;
            margin-bottom: 20px;
            justify-content: flex-end;
        }

        &__close-icon {
            width: 18px;
        }

        &__content {
            padding: 20px;
        }

        &.place-right {
            margin-left: 25px !important;
        }

        &.place-left {
            margin-left: -25px !important;
        }

        &.place-top {
            margin-top: -15px;

            &:after {
                margin-left: -4px !important;
            }
        }

        &.place-bottom {
            margin-top: 15px;

            &:after {
                margin-left: -4px !important;
            }
        }

        &::after{
            background-color: inherit !important;
        }

        @media (max-width: 794px) {
            &.show {
                overflow: auto !important;
                max-width: 100% !important;
                width: 100% !important;
                height: 100% !important;
                top: 0 !important;
                left: 0 !important;
                margin: 0 !important;
                backdrop-filter: blur(10px) !important;
                background-color: rgba(236, 234, 233, 0.85) !important;
                opacity: 1 !important;
                color: #000;
                padding: 0 !important;

                &:before,
                &:after {
                    content: '';
                    display: none;
                }
            }

            &__close-container {
                display: flex;
            }

            &__container {
                margin: 110px 30px 30px;
            }

            &__content {
                padding: 20px;
                background: #fff;
                color: #424242;
                font-size: 0.889rem;
                line-height: 1.5rem;
                box-shadow: rgba(0, 0, 0, 0.05) 0px 4px 4px 0px;
                border-radius: 4px;
            }
        }
    }

    :target {
        scroll-margin-top: 65px;
    }
`;

const SiteGlobalStyles = ({children}) => {
    const infoIcon = useWebpFile(`${process.env.GATSBY_MEDIA_URL}/Icons/info-icon.png`);
    return (
        <GlobalStyles $infoIcon={infoIcon}>{children}</GlobalStyles>
    );
};

export default SiteGlobalStyles;
